import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/Card';
import { ClinicianForm } from '@/features/phase2/ClinicianForm';

export const Route = createFileRoute('/_authed/phase2/clinicians')({
  component: CliniciansScreen,
});

function CliniciansScreen() {
  const { t } = useTranslation('phase2');
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('clinicians.title', { defaultValue: 'HAES clinicians' })}
        </h1>
        <p className="max-w-2xl text-sm text-[color:var(--color-fg-muted)]">
          {t('clinicians.subtitle', {
            defaultValue:
              'Curate the HAES-aligned clinician directory. Upserts on slug — re-saving the same slug updates the existing record. Publishing stamps the verification metadata.',
          })}
        </p>
      </header>

      <Card>
        <CardContent className="pt-6">
          <p className="mb-4 text-xs text-[color:var(--color-fg-muted)]">
            {t('clinicians.listOpenQuestion', {
              defaultValue:
                "No list endpoint is documented yet — the directory home is form-only. We'll wire the list once the backend exposes it.",
            })}
          </p>
          <ClinicianForm />
        </CardContent>
      </Card>
    </div>
  );
}
